import { useFormStore } from "../../store/transaction-certificates.store";
import { Utills } from "../app-configs/utilit";

export const useFormActions = (pageName: string) => {
    const setFormValues = useFormStore((state) => state.setFormValues);
    const getFormValues = useFormStore((state) => state.getFormValues);
    const setTableData = useFormStore((state) => state.setTableData);
    const getTableData = useFormStore((state) => state.getTableData);
    const resetAllPages = useFormStore((state) => state.resetAllPages);
    const updateTableRow = useFormStore((state) => state.updateTableRow);
    const removeTableRow = useFormStore((state) => state.removeTableRow)
    const removeTableRowByCondition = useFormStore((state) => state.removeTableRowByCondition)
    const replaceTableData = useFormStore((state) => state.replaceTableData);
    const setEditDataSave = useFormStore((state) => state.setEditSave);
    const getEditDataSave = useFormStore((state) => state.getEditSave);
    const setDeleteDataSave = useFormStore((state) => state.setDeleteSave);
    const getDeleteDataSave = useFormStore((state) => state.getDeleteSave);
    const getNewSavedData = useFormStore((state) => state.getNewTCSaved);
    const resetAllDataPageSpecific = useFormStore((state) => state.resetAllDataByPage)
    const setNewTCSaved = useFormStore((state) => state.setNewTCSaved);
    const resetPageFormFields = useFormStore((state) => state.resetPageFields);

    const resetPageFormWithIntialVal = useFormStore((state) => state.resetSpecificPage);
    const setNewDataTCSaved = (val: any) => {
        setNewTCSaved(pageName, val)
    };
    const resetFormValueByPage = () => {
        resetPageFormFields(pageName);  // Corrected invocation of resetPageFields
    };

    const getNewTCSave = () => getNewSavedData(pageName);
    const resetAllDataByPage = () => {
        resetAllDataPageSpecific(pageName)
    }
    const setEditSave = (value: boolean) => {
        setEditDataSave(pageName, value)
    };
    const setDeleteSave = (value: boolean) => {
        setDeleteDataSave(pageName, value)
    };

    const getEditSave = () => getEditDataSave(pageName);
    const getDeleteSave = () => getDeleteDataSave(pageName);

    const replaceTableDatas = (newData: any[]) => {
        replaceTableData(pageName, newData);
    };
    const updateTableRowbyIndex = (id: number, newData: any) => {
        updateTableRow(pageName, id, newData)
    }
    const removeTableRowbyIndex = (id: number) => {
        removeTableRow(pageName, id)
    }
    const removeExistingRecordFromTable = (condition: (row: any) => boolean) => {
        removeTableRowByCondition(pageName, condition);
    };
    const updateField = (name: string, value: any) => {
        setFormValues(pageName, { [name]: value });
        const savedValues = getFormValues(pageName);
    };

    const resetAllDatas = () => {
        resetAllPages();
    };

    const updateTableData = (data: any) => {
        setTableData(pageName, data);
    };

    const resetPageInitialState = (data: any) => {
        resetPageFormWithIntialVal(pageName, data)
    };
    const getCurrentFormValues = () => getFormValues(pageName);
    const getCurrentTableData = () => getTableData(pageName);

    return {
        updateField,
        updateTableData,
        getCurrentFormValues,
        getCurrentTableData,
        resetAllDatas,
        updateTableRowbyIndex,
        removeTableRowbyIndex,
        removeExistingRecordFromTable,
        replaceTableDatas,
        setEditSave,
        setDeleteSave,
        getEditSave,
        getDeleteSave,
        setNewDataTCSaved,
        getNewTCSave,
        resetAllDataByPage,
        resetFormValueByPage,
        resetPageFormFields,
        resetPageInitialState
    };
};

